import React from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
// Components
import Button from "../Button/Button"
// Styles
import { Container, Image, Info, Title, Square } from "./Category.styles"

const Category = ({ item }) => {
   const { t } = useTranslation()

   return (
      <Container>
         <Link to={`/products/${item.category}`}>
            <Image src={item.img} />
            <Square />
            <Info>
               <Title>{item.title}</Title>
               <Button text={t("category.button.b1")} />
            </Info>
         </Link>
      </Container>
   )
}

Category.propTypes = {
   item: PropTypes.object,
}

export default Category
